import React from "react";
import SearchBar from "../../../../components/admin/usable/SearchBar";
import AddButton from "../../../../components/admin/usable/AddButton";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsBulkEnable,
  setShowFileUploader,
} from "../../../../redux/admin/fileManagerSlice";

const SectionOne = ({ Search, setSearch, handleDelete }) => {
  const dispatch = useDispatch();
  const { isBulkEnable, multiSelected } = useSelector((state) => state.file);

  const handleShow = () => {
    dispatch(setShowFileUploader(true));
  };
  const handleBulk = () => {
    dispatch(setIsBulkEnable(!isBulkEnable));
  };

  return (
    <div className="flex justify-between items-center">
      <div className="flex justify-start items-center gap-x-3">
        <SearchBar
          onChange={(e) => setSearch(e.target.value)}
          text="Search any media..."
        />
        <div className="flex justify-start items-center gap-x-3">
          {isBulkEnable && multiSelected.length > 0 && (
            <button
              onClick={handleDelete}
              className="px-4 py-3 rounded-lg bg-[#0f033d] text-white text-xs scale-100 hover:scale-105 transition-all duration-300"
            >
              Delete
            </button>
          )}
          <button
            onClick={handleBulk}
            className={`px-4 py-3 rounded-lg ${
              isBulkEnable ? "bg-[#e60347]" : "bg-[#07704d]"
            } text-white text-xs scale-100 hover:scale-105 transition-all duration-300`}
          >
            {isBulkEnable ? "Cancel" : "Select Bulk"}
          </button>
        </div>
      </div>
      <div>
        <AddButton onClick={handleShow} text="Add Media" />
      </div>
    </div>
  );
};

export default SectionOne;
